import { ReactNode } from 'react';
import { Link } from '@mui/material';

/** Rich Text Formatting that wraps text in an <em> tag. */
export const Emphasis = (chunks: Array<ReactNode>) => <em>{chunks}</em>;

/** Rich Text Formatting that wraps text in a <strong> tag. */
export const Strong = (chunks: Array<ReactNode>) => <strong>{chunks}</strong>;

/** Rich Text Formatting that wraps text in an underline component. */
export const Underline = (chunks: Array<ReactNode>) => (
  <span style={{ textDecoration: 'underline' }}>{chunks}</span>
);

/** Rich Text Formatting that wraps text in a link tag with a `tel` href. */
export const PhoneLink = (chunk: Array<ReactNode>) => <Link href={`tel:${chunk}`}>{chunk}</Link>;

/** Rich Text Formatting that wraps text in a link tag with a `mailto` href. */
export const EmailLink = (chunk: Array<ReactNode>) => <Link href={`mailto:${chunk}`}>{chunk}</Link>;

/** Support email address as a link tag with a `mailto` href. */
export const SupportEmailLink = EmailLink(['support@plooto.com']);
